if (window.history.scrollRestoration) {
	window.history.scrollRestoration = "manual";
}
